import type {
  GroupAnalysisData,
  Span,
} from '@/generated/types/navigator/types.gen';
/**
 * Utility functions for custom list operations
 */

/**
 * Determines if there are more items to load based on the total count and current items length
 * @param total - The total number of items available
 * @param currentItemsLength - The number of items currently loaded
 * @returns true if there are more items to load, false otherwise
 */
export const hasMoreToLoad = (
  total: number | null | undefined,
  currentItemsLength: number
): boolean => {
  return currentItemsLength < (total ?? 0);
};

// Helper for merging paginated items while preventing duplicates
export const mergeSpanItems = <T extends { level2: string; level3: string }>(
  previousItems: T[],
  newItems: T[],
  isFirstPage: boolean
): T[] => {
  if (isFirstPage) {
    return [...newItems];
  }

  // Create a set of existing item IDs to check for duplicates
  const existingIds = new Set(
    previousItems.map((span) => `${span.level2}-${span.level3}`)
  );

  // Filter out items that already exist
  const uniqueNewItems = newItems.filter(
    (span) => !existingIds.has(`${span.level2}-${span.level3}`)
  );

  return [...previousItems, ...uniqueNewItems];
};

export const transformSpansToAnalyses = (spans: Span[]): GroupAnalysisData[] =>
  spans.flatMap((item) => (item.analysis ? [item.analysis] : []));
